export const CAN_EDIT_PROGRAM_SETTINGS = 1 << 0;
export const CAN_EDIT_PROGRAM_CONTENT = 1 << 1;

/** time after which stats are no longer considered fresh */
export const OUTDATED_INTERVAL_STATS = 30 * 60 * 1000;
